export default "__VITE_ASSET__Bb249NXv__"